<ng-template #errorCampo let-clave="clave">
  <div class="cf-field__error" *ngIf="mensaje(clave) as texto"><mat-icon>error</mat-icon> {{ texto }}</div>
</ng-template>

<div class="m182-page">

  <ng-container *ngIf="isLoading">
    <div class="m182-loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Cargando datos...</p>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading">

    <div class="m182-header">
      <div class="m182-header__icon"><mat-icon>volunteer_activism</mat-icon></div>
      <div>
        <h5 class="m182-header__title">Modelo 182</h5>
        <p class="m182-header__sub">Declaración informativa de donativos, donaciones y aportaciones recibidas</p>
      </div>
    </div>

    <div class="m182-actions">
      <button mat-stroked-button class="cf-btn" (click)="calcular()">
        <mat-icon>refresh</mat-icon> Calcular
      </button>
      <button mat-stroked-button class="cf-btn" (click)="validate()">
        <mat-icon>search</mat-icon> Validar
      </button>
      <button mat-stroked-button class="cf-btn" (click)="saveDraft()" [disabled]="isSaving">
        <mat-icon>save</mat-icon> Guardar borrador
      </button>
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="getFile()">
        <mat-icon>file_download</mat-icon> Descargar fichero
      </button>
      <button mat-stroked-button class="cf-btn" [matMenuTriggerFor]="masAcciones">
        <mat-icon>more_horiz</mat-icon> Más
      </button>
      <mat-menu #masAcciones="matMenu">
        <button mat-menu-item (click)="ficheroImportado.click()">
          <mat-icon>upload_file</mat-icon> Importar fichero
        </button>
        <button mat-menu-item (click)="openHistory()">
          <mat-icon>history</mat-icon> Historial de presentaciones
        </button>
        <button mat-menu-item (click)="marcarPresentada()" [disabled]="!declaracionActual">
          <mat-icon>check_circle</mat-icon> Marcar como presentada
        </button>
        <button mat-menu-item (click)="redirectFileTax()" [disabled]="!path">
          <mat-icon>send</mat-icon> Presentar en la sede
        </button>
        <button mat-menu-item (click)="descartarBorrador()" [disabled]="!declaracionActual">
          <mat-icon>restore</mat-icon> Descartar borrador
        </button>
      </mat-menu>
      <input #ficheroImportado type="file" accept=".182,.txt" hidden (change)="importFile($event)" />
      <span class="m182-actions__spacer"></span>

      <button mat-stroked-button class="cf-btn" (click)="alternarTodo()">
        <mat-icon>{{ todoCompactado ? 'unfold_more' : 'unfold_less' }}</mat-icon>
        {{ todoCompactado ? 'Expandir todo' : 'Compactar todo' }}
      </button>
    </div>

    <div class="m182-alerts" *ngIf="validations.length">
      <div class="m182-alert" *ngFor="let item of validations; trackBy: trackByIndex"
        [class.m182-alert--warning]="item.type === 'WARNING'">
        <mat-icon>{{ item.type === 'WARNING' ? 'warning' : 'error_outline' }}</mat-icon>
        <span class="m182-alert__text">{{ item.message }}</span>
        <button type="button" *ngIf="item.key" class="m182-alert__link" (click)="irAlCampo(item)">
          {{ declaradoDe(item) >= 0 ? 'Ver declarado' : 'Ir al campo' }}
        </button>
      </div>
    </div>

    <div class="m182-layout">

      <aside class="m182-rail">
        <div class="m182-rail__block">
          <label class="m182-rail__label" for="buscador">Buscador de campos</label>
          <div class="m182-rail__buscador">
            <input id="buscador" class="m182-input m182-rail__input" name="buscador" type="text"
              placeholder="NIF" [(ngModel)]="buscadorCampo" (keyup.enter)="irAlCampoBuscado()" />
            <button mat-flat-button class="cf-btn cf-btn--primary" (click)="irAlCampoBuscado()">Ir al campo</button>
          </div>
        </div>

        <div class="m182-rail__block">
          <span class="m182-rail__label">Estado</span>
          <span class="m182-pill m182-pill--{{ varianteDeclaracion }}">{{ estadoDeclaracion }}</span>
          <span class="m182-rail__nota" *ngIf="declaracionActual?.fileName">{{ declaracionActual.fileName }}</span>
        </div>

        <div class="m182-rail__block">
          <span class="m182-rail__label">Secciones</span>
          <button type="button" class="m182-rail__seccion" *ngFor="let seccion of secciones; let i = index"
            [class.m182-rail__seccion--activa]="seccionActiva === seccion.clave" (click)="irALaSeccion(seccion.clave)">
            <span class="m182-rail__seccion-texto">
              <span class="m182-rail__seccion-numero">{{ i + 1 }} -</span>
              {{ seccion.titulo }}
            </span>
            <mat-icon class="m182-rail__seccion-check" *ngIf="confirmada(seccion.clave)">check_circle</mat-icon>
            <span class="m182-rail__seccion-hueco" *ngIf="!confirmada(seccion.clave)"></span>
          </button>
        </div>
      </aside>

      <div class="m182-sections">

        <div class="m182-card" id="region-declarante" [class.m182-card--collapsed]="colapsada('declarante')">
          <div class="m182-card__head" (click)="toggleRegion('declarante')">
            <mat-icon>perm_identity</mat-icon>
            <span class="m182-card__head-label">1 - Declarante</span>
            <mat-icon class="m182-card__check" *ngIf="confirmada('declarante')">check_circle</mat-icon>
            <mat-icon class="m182-card__chevron">{{ colapsada('declarante') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m182-card__body">
            <div class="m182-fields">
              <div class="m182-field m182-field--3 cf-field--required" [class.cf-field--invalid]="!!mensaje('sujetoNIF')">
                <app-ui-input id="sujetoNIF" name="sujetoNIF" [(ngModel)]="data.sujetoNIF"
                  [config]="{ label: 'NIF', maxLength: 9 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'sujetoNIF' }"></ng-container>
              </div>
              <div class="m182-field m182-field--6 cf-field--required" [class.cf-field--invalid]="!!mensaje('sujetoDenominacion')">
                <app-ui-input id="sujetoDenominacion" name="sujetoDenominacion" [(ngModel)]="data.sujetoDenominacion"
                  [config]="{ label: 'Denominación de la entidad' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'sujetoDenominacion' }"></ng-container>
              </div>
              <div class="m182-field m182-field--3 cf-field--required" [class.cf-field--invalid]="!!mensaje('ejercicio')">
                <app-select id="ejercicio" name="ejercicio" [ngModel]="ejercicioSel"
                  (ngModelChange)="ejercicioSel = $event; cambiarEjercicio()"
                  [config]="{ label: 'Ejercicio', options: ejercicioOptions }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'ejercicio' }"></ng-container>
              </div>
              <div class="m182-field m182-field--12 cf-field--required" [class.cf-field--invalid]="!!mensaje('naturalezaDeclarante')">
                <app-select id="naturalezaDeclarante" name="naturalezaDeclarante" [ngModel]="data.naturalezaDeclarante"
                  (ngModelChange)="onNaturaleza($event)"
                  [config]="{ label: 'Naturaleza del declarante', options: naturalezaOptions }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'naturalezaDeclarante' }"></ng-container>
              </div>
              <div class="m182-field m182-field--3 cf-field--required" [class.cf-field--invalid]="!!mensaje('telefono')">
                <app-ui-input id="telefono" name="telefono" [(ngModel)]="data.telefono"
                  [config]="{ label: 'Teléfono', maxLength: 9, inputmode: 'tel' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'telefono' }"></ng-container>
              </div>
              <div class="m182-field m182-field--9 cf-field--required" [class.cf-field--invalid]="!!mensaje('contacto')">
                <app-ui-input id="contacto" name="contacto" [(ngModel)]="data.contacto"
                  [config]="{ label: 'Apellidos y nombre de la persona con quien relacionarse' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'contacto' }"></ng-container>
              </div>
            </div>
          </div>
          <div class="m182-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('declarante')">
              <mat-icon>check</mat-icon> Declarante confirmado
            </button>
          </div>
        </div>

        <div class="m182-card" id="region-declaracion" [class.m182-card--collapsed]="colapsada('declaracion')">
          <div class="m182-card__head" (click)="toggleRegion('declaracion')">
            <mat-icon>description</mat-icon>
            <span class="m182-card__head-label">2 - Declaración</span>
            <mat-icon class="m182-card__check" *ngIf="confirmada('declaracion')">check_circle</mat-icon>
            <mat-icon class="m182-card__chevron">{{ colapsada('declaracion') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m182-card__body">
            <div class="m182-fields">
              <div class="m182-field m182-field--4" [class.cf-field--invalid]="!!mensaje('sustitutiva')">
                <app-select id="sustitutiva" name="tipoDeclaracion" [ngModel]="tipoSel"
                  (ngModelChange)="onTipo($event)"
                  [config]="{ label: 'Tipo de declaración', options: tipoDeclaracionOptions }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'sustitutiva' }"></ng-container>
              </div>
              <div class="m182-field m182-field--4" *ngIf="esAnterior" [class.cf-field--invalid]="!!mensaje('justificanteAnterior')">
                <app-ui-input id="justificanteAnterior" name="justificanteAnterior" [ngModel]="data.justificanteAnterior"
                  (ngModelChange)="onJustificanteAnterior($event)"
                  [config]="{ label: 'Nº de justificante de la declaración anterior', maxLength: 13 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'justificanteAnterior' }"></ng-container>
              </div>
              <div class="m182-field m182-field--4 cf-field--required" [class.cf-field--invalid]="!!mensaje('justificante')">
                <app-ui-input id="justificante" name="justificante" [(ngModel)]="data.justificante"
                  [config]="{ label: 'Nº de justificante de esta declaración', maxLength: 13 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'justificante' }"></ng-container>
              </div>
            </div>
          </div>
          <div class="m182-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('declaracion')">
              <mat-icon>check</mat-icon> Declaración confirmada
            </button>
          </div>
        </div>

        <div class="m182-card" id="region-resumen" [class.m182-card--collapsed]="colapsada('resumen')">
          <div class="m182-card__head" (click)="toggleRegion('resumen')">
            <mat-icon>summarize</mat-icon>
            <span class="m182-card__head-label">3 - Resumen de totales</span>
            <mat-icon class="m182-card__check" *ngIf="confirmada('resumen')">check_circle</mat-icon>
            <mat-icon class="m182-card__chevron">{{ colapsada('resumen') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m182-card__body">
            <div class="m182-fields">
              <div class="m182-field m182-field--3" id="numeroRegistros">
                <span class="m182-calc__label">Número total de registros</span>
                <input class="m182-input m182-input--calc" readonly tabindex="-1"
                  [value]="data.numeroRegistros | number:'1.0-0'" />
              </div>
              <div class="m182-field m182-field--3" id="importeTotal">
                <span class="m182-calc__label">Importe total</span>
                <input class="m182-input m182-input--calc" readonly tabindex="-1"
                  [value]="data.importeTotal | number:'1.2-2'" />
              </div>
            </div>
            <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'importeTotal' }"></ng-container>
          </div>
          <div class="m182-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('resumen')">
              <mat-icon>check</mat-icon> Resumen confirmado
            </button>
          </div>
        </div>

        <div class="m182-card" id="region-declarados" [class.m182-card--collapsed]="colapsada('declarados')">
          <div class="m182-card__head" (click)="toggleRegion('declarados')">
            <mat-icon>groups</mat-icon>
            <span class="m182-card__head-label">4 - Declarados</span>
            <mat-icon class="m182-card__check" *ngIf="confirmada('declarados')">check_circle</mat-icon>
            <mat-icon class="m182-card__chevron">{{ colapsada('declarados') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m182-card__body" id="declarados">
            <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'declarados' }"></ng-container>
            <app-model-182-declarados [data]="data" [validaciones]="validations"
              (nuevo)="nuevoDeclarado()" (editar)="editarDeclarado($event)"
              (eliminar)="eliminarDeclarado($event)" (origen)="verOrigen($event)"></app-model-182-declarados>
          </div>
          <div class="m182-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('declarados')">
              <mat-icon>check</mat-icon> Declarados confirmados
            </button>
          </div>
        </div>

        <div class="m182-card" id="region-presentacion" [class.m182-card--collapsed]="colapsada('presentacion')">
          <div class="m182-card__head" (click)="toggleRegion('presentacion')">
            <mat-icon>send</mat-icon>
            <span class="m182-card__head-label">5 - Presentación</span>
            <mat-icon class="m182-card__check" *ngIf="confirmada('presentacion')">check_circle</mat-icon>
            <mat-icon class="m182-card__chevron">{{ colapsada('presentacion') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m182-card__body">
            <div class="m182-presentar">
              <div class="m182-alerts" *ngIf="data.avisos.length">
                <div class="m182-alert m182-alert--warning" *ngFor="let aviso of data.avisos; trackBy: trackByIndex">
                  <mat-icon>warning</mat-icon>
                  <span class="m182-alert__text">{{ aviso }}</span>
                </div>
              </div>

              <div class="m182-guia" *ngIf="mostrarGuia">
                <div class="m182-guia__head">
                  <mat-icon>task_alt</mat-icon>
                  <span>Ya tienes el fichero <strong>{{ nombreFichero }}</strong>. Para presentarlo:</span>
                  <button type="button" class="m182-guia__close" (click)="mostrarGuia = false">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <ol class="m182-guia__pasos">
                  <li>Entra en la sede electrónica de la Agencia Tributaria con tu certificado.</li>
                  <li>Elige el modelo 182 y la opción de presentar con fichero.</li>
                  <li>Selecciona el fichero descargado.</li>
                  <li>Revisa, firma y presenta. Luego vuelve aquí y márcala como presentada.</li>
                </ol>
              </div>

              <div class="m182-presentar__acciones">
                <button mat-stroked-button class="cf-btn" (click)="validate()">
                  <mat-icon>search</mat-icon> Validar
                </button>
                <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="getFile()">
                  <mat-icon>file_download</mat-icon> Descargar fichero
                </button>
                <button mat-stroked-button class="cf-btn" (click)="redirectFileTax()" [disabled]="!path">
                  <mat-icon>open_in_new</mat-icon> Presentar en la sede
                </button>
                <button mat-stroked-button class="cf-btn" (click)="marcarPresentada()" [disabled]="!declaracionActual">
                  <mat-icon>check_circle</mat-icon> Marcar como presentada
                </button>
              </div>
            </div>
          </div>
          <div class="m182-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('presentacion')">
              <mat-icon>check</mat-icon> Presentación confirmada
            </button>
          </div>
        </div>

      </div>
    </div>

  </ng-container>
</div>
